import {Box, IconButton, Stack, Typography} from "@mui/material";
import {IconX} from "@tabler/icons-react";
import React, {useEffect, useMemo, useRef, useState} from "react";
import Modal from "@mui/material/Modal";
import GraphComponent from "../../components/GraphComponent";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "90vw",
  width: "100%",
  maxHeight: "90dvh",
  minHeight: "90dvh",
  height: "100%",
  bgcolor: 'background.paper',
  borderRadius: 0,
  border: '0px solid #000',
  boxShadow: 24,
  px: 4, py: 2,
  overflow: "hidden",
  zIndex: 100000000
};

export const GraphModal = ({open, handleClose, metadata}) => {
  const [parentWidth, setParentWidth] = useState(0); // State to track the parent width
  const [parentHeight, setParentHeight] = useState(0); // State to track the parent width
  const parentRef = useRef(null); // Reference for the parent Box

  // Set parent width on mount and resize
  useEffect(() => {
    if (!open || metadata?.length === 0) {
      return;
    }
    const handleResize = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.offsetWidth);
        setParentHeight(parentRef.current.offsetHeight);
      }
      console.log(parentRef?.current?.offsetHeight)
      console.log(parentRef?.current?.offsetWidth)
    };
    if (parentRef?.current) {
      setParentWidth(parentRef.current.offsetWidth);
      setParentHeight(parentRef.current.offsetHeight);
    }
    handleResize(); // Set initial width
    window.addEventListener("resize", handleResize); // Update on resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup on unmount
  }, [open, metadata, parentRef?.current]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={style}>
        <Stack direction={"row"} gap={1} justifyContent={"space-between"} alignItems={"center"}>
          <Typography variant={"h4"} fontWeight={600}>Metadata Graph</Typography>
          <IconButton onClick={handleClose}>
            <IconX/>
          </IconButton>
        </Stack>
        <Box ref={parentRef} sx={{flex: 1, minHeight: "60dvh"}}>
          {open && <GraphComponent metadata={metadata} width={parentWidth || 900} height={parentHeight || 700} />}
        </Box>
      </Stack>
    </Modal>
  )
}